module.exports = __webpack_public_path__ + "img/108.1fae8289.jpg";